'use client';
import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import SubscribeService from '@/app/services/subscribe';
import toast from "react-hot-toast";

export default function Subscribe() {
    const t = useTranslations('News')
    const t2 = useTranslations('General')
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("")

    async function subscribeToMail() {
        try {
            const result: any = await SubscribeService.subscribeEmail({email: email});
            if (result?.data?.success) {
                toast.success(t2('subscribe_email_success'));
            } else {
                toast.error(result?.data?.message ?? t2('subscribe_email_error'))
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? t2('subscribe_email_error'))
        } finally {
            setIsLoading(false)
        }
    }


    return (
        <div className='mt-4 md:mb-10 md:mt-20 px-4 md:px-20 text-start'>
            <div className='flex flex-col md:flex-row justify-start'>
                <div className='flex-2'>
                    <div className='md:pb-16'>
                        <h2 className='text-sm md:text-md max-w-sm leading-normal mt-6  uppercase'>
                            {t('newsletter')}
                        </h2>
                        <h1 className='text-xl md:text-[77px] leading-none text-start font-regular'>
                            {t('updates')}.
                        </h1>
                    </div>
                </div>
            </div>
            <div className='flex flex-col md:flex-row justify-start pb-4 mt-2'>
                <div className='flex-1'>
                    <div className='flex flex-col md:flex-row gap-1 justify-end'>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            autoComplete="email"
                            required
                            className="block w-full md:max-w-[350px] border-gray-300 p-3 border"
                            placeholder="Email"
                            onChange={(e: any) => {setEmail(e?.target?.value)}}
                        />
                        <button disabled={isLoading} className='bg-primary-gradient text-white px-4 py-2 md:py-0 cursor-pointer' onClick={subscribeToMail}>
                            {t('subscribe')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
